

















































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbMember } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
import Bus from '@/common/util/bus';
import { Toast } from 'vant';
@Component({
    components: {
    },
})
export default class payPanel extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };


    show = false;

    @Prop({
      default: false,
    })
    hasOrderId: Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return{

            }
        }
    })
    orderInfo:any;


    fmoney = fmoney;

    /**计时器 */
    count = 120;
    interval=null;
    count2 = 300;
    interval2=null;

    /**扫完付款码后 */
    isPaying = false;

    /**无效扫码 */
    warnScanVal='';
    warnScanShow=false;

    /**移动支付-关闭操作提醒 */
    ydPayCloseTipShow=false;

    /**支付方式名称 */
    get payName(){
        let str = "";
        switch (this.orderInfo.paymentMethod) {

            case 2:
                str = "现金支付"
                break;
            case 3:
                str = "微信"
                break;
            case 4:
                str = "支付宝"
                break;

            default:
                break;
        }
        return str;
    }

    @Watch('isPaying')
    payingChange(val){
        if(val==true){
            this.interval2 = setInterval(async () => {
                this.count2--;
                if(this.count2<=0){
                    this.closeFun();
                return;
            }
        }, 1000);
        }
    }

    created() {

    }
    showFun(){
        this.isPaying = true;
        this.count = 120;
        this.count2 = 300;
        // clearInterval(this.interval)
        // clearInterval(this.interval2);
        this.interval = setInterval(async () => {
            this.count --;
            if(this.count<=0){
                // clearInterval(this.interval);
               this.closeFun();
            }
        }, 1000);
        Bus.$emit('isVipPaying',true);


        // Bus.$on('resultVipPayCode',(val)=>{

        // this.isPaying = true;
        // (this.$parent as any).startPay(val);


        // });
        this.show = true;
        this.getInputFocus()

    }

    mounted() {
    }
    beforeUnmount() {
    		clearInterval(this.interval);
    		clearInterval(this.interval2);
    		this.interval = null;
    		this.interval2 = null;
    		Bus.$emit('isVipPaying',false);
    	}


    scanInput(val){
        if(!this.isPaying)return;
        // 微信付款码
        			let req = /^1[0-6][0-9]{16}$/;
        			// 支付宝付款码
        			let req2 = /^(?:2[5-9]|30)\d{14,22}$/;
        		// 扫描到无效条形码
        		if(!req.test(val)&&!req2.test(val)){
        			// 暂停所有倒计时（120秒等待扫码 + 300秒支付中），避免弹窗期间被自动关闭
        			clearInterval(this.interval);
        			clearInterval(this.interval2);
        			this.interval = null;
        			this.interval2 = null;
        			this.warnScanVal = val;
        			this.warnScanShow = true;
        			return;
        		}
        			// 停止120秒等待扫码倒计时，避免与支付中倒计时(interval2)并行
        			clearInterval(this.interval);
        			this.interval = null;
        (this.$parent as any).startPay(val);
    }

    /**条码异常-确定，恢复扫码倒计时 */
    		onWarnScanConfirm(){
    			// 防御：创建新定时器前先清除旧的，避免叠加
    			clearInterval(this.interval);
    			clearInterval(this.interval2);
    			this.interval = null;
    			this.interval2 = null;
    			this.count = 120;
    			this.count2 = 300;
    			this.interval = setInterval(async () => {
    				this.count --;
    				if(this.count<=0){
    				   this.closeFun();
    				}
    			}, 1000);
    			// isPaying 仍为 true，watch 不会自动重启，需手动恢复支付中倒计时
    			this.interval2 = setInterval(async () => {
    				this.count2--;
    				if(this.count2<=0){
    					this.closeFun();
    					return;
    				}
    			}, 1000);
    			this.warnScanShow = false;
    		}
        /**移动支付-取消，弹二次确认 */
        	closeFunHand2(){
        		this.ydPayCloseTipShow = true;
        	}
        	/**确定关闭-通知父组件停止轮询 */
        	onydPayClose(){
        		this.ydPayCloseTipShow = false;
        		this.closeFun();
        		this.$emit('cancelPay');
        	}
        	/**再等等-仅关闭确认框 */
        	onydPayCloseWait(){
        		this.ydPayCloseTipShow = false;
        	}

    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    closeFun(){
        this.isPaying = false;
        this.count = 0;
        this.count2 = 0;
        clearInterval(this.interval)
        clearInterval(this.interval2)
        this.interval = null;
       this.interval2 = null;
        // this.$emit("closeFun");
        Bus.$emit('isVipPaying',false);
        this.show = false;
        document.removeEventListener('keydown',this.handleScanCode)
        document.removeEventListener('click', this.chargeInputFocus)

    }
    payFun(){
        this.$emit("payFun");
        this.closeFun();
        document.removeEventListener('keydown',this.handleScanCode)
        document.removeEventListener('click', this.chargeInputFocus)
    }


    @Watch("show")
    public showChange(val: boolean) {
        if (val) {
            document.addEventListener('click',this.chargeInputFocus)
        }
    }
    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
            this.getInputFocus()

        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode)
        document.removeEventListener('click', this.chargeInputFocus)

    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if (event.key === 'Enter' || event.keyCode == 13) {
            let code = this.scanCodes?this.scanCodes:event.target.value
            this.scanInput(code)
            this.scanCodes = ''
        return
        }
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/payPanel.vue